// src/context/SearchResultsContext.js
import React, { createContext, useContext, useState } from "react";

const SearchResultsContext = createContext();

export const useSearchResults = () => {
  const context = useContext(SearchResultsContext);
  if (context === undefined) {
    throw new Error(
      "useSearchResults must be used within a SearchResultsProvider",
    );
  }
  return context;
};

export const SearchResultsProvider = ({ children }) => {
  const [results, setResults] = useState(null);

  return (
    <SearchResultsContext.Provider value={{ results, setResults }}>
      {children}
    </SearchResultsContext.Provider>
  );
};
